import React, { useEffect, useState, useContext } from "react";
import CardContent from "@material-ui/core/CardContent";
import API from "../../services/api";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder.svg";
import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import "./style.css";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Amplitude from "amplitudejs";
import TrackContext from "../../contexts/track-context";
import Tabs from "@material-ui/core/Tabs";
import { ReactComponent as Play } from "../../assets/play.svg";
import { ReactComponent as Pause } from "../../assets/pause.svg";
import { ReactComponent as Close } from "../../assets/close.svg";
import AlternateTracks from "./alternate-tracks";
import CookieManager from "../../services/CookieManager";
import { Link, useHistory, useParams } from 'react-router-dom';
import { BouncingLoader } from "../../pure-components/Loader";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";
import RippleLoader from "../../assets/loader-2.gif";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";
import Constants from "../../services/constants";
import SvgInline from "../../pure-components/SvgInLine";
import MewoService from "../../services/mewoService";
import { CircularProgress } from "@material-ui/core";


export default function Track(props) {

  let trackContext = useContext(TrackContext);
  const { filterMenu, setFilterMenu, setFilterSubMenu, setFilterSubMenuchild } = trackContext;
  const [favs, setFavs] = useState([]);
  const [download, setDownload] = useState([]);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadModalPosition, setDownloadModalPosition] = useState(null);
  const [ChidDownloadModalPosition, setChilddownloadModalPosition] = useState(null);
  const [hdmp3File, setHdmp3File] = useState(false);
  const [originalFile, setOriginalFile] = useState(false);
  const [alternateVersions, setAlternateVersions] = useState([]);
  const [expand, setExpand] = useState(false);
  const [showLoader, setShowLoader] = useState(false)
  const { searchTags } = trackContext.trackFilter;
  const history = useHistory();
  const { playlistId, albumId } = useParams()
  const [versionLoading, setVersionLoading] = useState(false);
  const [downloadingTrack, setDownloadingTrack] = useState("");

  useEffect(() => {
    if (localStorage.getItem("favs") && localStorage.getItem("favs") !== 'undefined' && localStorage.getItem("favs") !== 'null') {
      const favorites = JSON.parse(localStorage.getItem("favs") || "{}");
      if(Object.keys(favorites)?.length > 0)
        setFavs(Object.keys(favorites));
    }
    if (localStorage.getItem("download") !== "undefined") {
      const download = JSON.parse(localStorage.getItem("download"));
      download !== null && setDownload(download);
    }
  }, []);

  const fetchTrack = (trackId, isAltVersion ,description= false) => {
    console.log("fetchTrack description", { isAltVersion });
    console.log("fetchTrack called with:", { trackId, isAltVersion });
  
    if (trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }
  
    trackContext.setpreviousTrack(props.previousTrack);
    console.log("Previous Track Set:", props.previousTrack);
  
    props.setFetchingTrack(true);
    console.log("Fetching track data...");
  
    API.playTrack(trackId)
      .then((res) => {
        props.setFetchingTrack(false);
        console.log("API Response:", res);
  
        if (res?.data?.success) {
          const trackData = res.data.data;
          const artistData = trackData.artists_publishing_ownerships;
  
          console.log("Artist Data from API:", artistData);
  
          const artist = artistData?.length > 0 ? artistData[0]?.artist?.full_name : "Unknown Artist";
          const description = artistData?.length > 0 ? artistData[0]?.description?.description : "Unknown Artist";          
          const artistType = artistData?.length > 0 ? artistData[0]?.rights_type?.key : "Unknown Type";
  
          // Fetching music description
          console.log(trackData,"trackData") 
  
          console.log("Extracted Artist:", artist);
          console.log("Extracted Artist Type:", artistType);
          console.log("Extracted Music Description:", description);
  
          trackContext.setPlayingFrom(props.pageId);
          trackContext.setalltrackData(trackContext.trackData);
          trackContext.setCurrentTrack(trackData.audiofile);
  
          trackContext.setCurrentTrackDetail({
            ...trackData,
            tags: props.tags,
            artist: artist,
            artist_type: artistType,
            description: description, // Added description here
          });
  
          console.log("Updated Track Details:", {
            tags: props.tags,
            artist: artist,
            artist_type: artistType,
            description: description,
          });
        } else {
          console.error("API Error:", res?.data);
          Helper.handleError(res?.data);
        }
      })
      .catch((error) => {
        console.error("API Call Failed:", error);
        Helper.handleError(error);
      });
  };

  const playTrack = async(trackData) => {
    if (trackData.trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      // console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      // console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }

    trackContext.setPlayingFrom(props.pageId)
    trackContext.setCurrentTrack(Helper.playTrackURL(trackData.trackId));
    trackContext.setCurrentTrackDetail({id : trackData.trackId, 
      display_title : trackData.title,
      description : trackData.description || "",
      duration : trackData.duration,
      bpm : trackData.bpm, 
      album : {id : trackData.albumId, name : trackData.album, image : {original : {url : Helper.getArtworkURL(trackData.albumId)}}},
      artist: trackData.artistName,
      isVersion : trackData.isVersion || false
    });
    
    const dataObj = {
      actionType : Constants.ACTION.PLAY,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addPlayHistory(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("history", JSON.stringify(res.history)); 
      } else {
        console.log("Track Adding in play history failed.", res);
      }
    }).catch(err => {
      console.log("Track Adding in play history failed.", err);
    });
  }

  const magicWandSearch = (trackData) => {
    //TODO : change this as we change musicFilter obj
    const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(CookieManager.getCookie("harmix-music-filter")) : { "searchText": "", "type": Constants.SEARCH_TYPE.text };
    tempFilter.type = Constants.SEARCH_TYPE.track;
    tempFilter.searchText = trackData.title;
    tempFilter.searchRef = trackData.id;
    tempFilter.segment = null;
    CookieManager.setCookie("harmix-music-filter", JSON.stringify(tempFilter));
    history.push(`/library/${trackData.id}`, {searchedTrackData : {...trackData}})
  }

  const downloadTrack = async (trackId) => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
      props.setDownloadingTracks([...props.downloadingTracks, trackId])
      const filter = {
        "Identifier": trackId,
        "DownloadType": "track",
        "Format": "mp3",
        "TrimStartSecs": 0,
        "TrimEndSecs": 0,
        "Email": cachedUserData.email,
        "IsShare": false,
        "Message": "",
        "SenderEmail": "",
        "ForceEmail": true,
        "IncludeVersions": false,
        "VersionFolderName": "",
        "DownloadFileName": "",
        "CuesheetFileName": "",
        "IncludeCuesheetFile": false
      }

      await API.downloadTrack(filter).then(resp => {
        if(resp.success)
          toast(({ closeToast }) => <SuccessToast message={"Download link shared on your email, please check your inbox."} />);
        else
          toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + resp.mssg} />);
      }).catch(err =>{
        toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + err.mssg} />);
      }).finally(() => {
        const tempData = props.downloadingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(trackId), 1);
        props.setDownloadingTracks(tempData);
      })

  };

  const fetchAltVersion = async (trackId, altVersionCount, expandval = false) => {
  if (expandval) {
      
      setVersionLoading(true);
      const filter = {
        "ReturnAlternateVersions":"true",
        "ReturnAttributes":"true",
        "ReturnCategories":"true",
        "ReturnCategoryFacet":"true",
        "ReturnCodes":"true",
        "ReturnComposers":"true",
        "ReturnRelatedTracks":"false",
        "ReturnRightHolders":"false",
        "GetMainVersionFromAlternate":"false",
        "CuesheetOnlyCodesAndAttribute":"false",
        "ReturnInactiveTracks":"false",
        "ReturnRegionOnlyTracks":"false",
        "Offset":"0",
        "Limit":"100",
        "track":[trackId]
      }
      let trackVersions = [];
      if(altVersionCount > 0)
        trackVersions = await API.loadTrackData(filter).then((resp) => {
          // console.log("Track version Data : ", resp);
          return resp.data?.Tracks[0]?.AlternateTracks;
            // if (resp?.length > 0) {
            //   // setAlternateVersions(res);
            // } else {
            //   let altVer = {
            //     album: { title: props.album },
            //     artists_publishing_ownerships: [
            //       {
            //         artist: { full_name: props.artist.full_name },
            //         rights_type: { key: props.rights_type },
            //       },
            //     ],
            //     master_ownerships: [{ label: { label_name: props.producer } }]
            //   };

            //   setAlternateVersions([{ ...altVer }]);
            // }
            // setExpand(expandval);
            // props.setExpandedTrackId(trackId);
          
        }).catch((err) => {
          console.log("Error Loading Track Versions : ", err);
          toast(({ closeToast }) => <ErrorToast message={"Error Loading Track Versions."} />);
        }).finally(() => {
          setVersionLoading(false);
        })

      if (altVersionCount > 0) {
        // console.log("alternater versions : ", trackVersions);
        setAlternateVersions(trackVersions);
      }
      //TODO : Remove this block 
      else {
        let altVer = {
          album: { title: props.album },
          artists_publishing_ownerships: [
            {
              artist: { full_name: props.artistName },
              rights_type: { key: props.rights_type },
            },
          ],
          master_ownerships: [{ label: { label_name: props.producer } }]
        };

        setAlternateVersions([{ ...altVer }]);
      }
      setExpand(expandval);
      props.setExpandedTrackId(trackId);


      // await MewoService.loadMewoData(reqObj).then((res) => {
      //   if (res) {
      //     if (res?.length > 0) {
      //       setAlternateVersions(res);
      //     } else {
      //       let altVer = {
      //         album: { title: props.album },
      //         artists_publishing_ownerships: [
      //           {
      //             artist: { full_name: props.artist.full_name },
      //             rights_type: { key: props.rights_type },
      //           },
      //         ],
      //         master_ownerships: [{ label: { label_name: props.producer } }]
      //       };

      //       setAlternateVersions([{ ...altVer }]);
      //     }
      //     setExpand(expandval);
      //     props.setExpandedTrackId(trackId);
      //   } else {
      //     Helper.handleError(res);
      //   }
      // })
      //   .catch((err) => {
      //     toast(({ closeToast }) => (
      //       <ErrorToast message={"Error Loading Track Versions : " + err?.response?.data?.message} />
      //     ));

      //   });
    } else {
      setExpand(expandval);
    }
  };

  const handleProjectModal = (trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    props.displayProjectModal(trackId);

  };


  const handleThumbPrintSearch = async (props) => {
    trackContext.setShowLoaderMagic(true);

    let reqObj = {
      url: 'public/search',
      method: 'post',
      data: {
        "query": "",
        "options":
        {
          "trackId": props.trackId,
          "filters": {
            exclude: [],
            ...props.searchTags,
          },
          "size": Constants.MEWO_TRACK_SEARCH_BATCH_SIZE,
          "search_descriptions": trackContext.searchDescription ? trackContext.searchDescription : false
        }
      }
    };
    await MewoService.loadMewoData(reqObj).then(res => {
      if (res?.hits) {
        let newRes = res.hits;
        let [, ...magicWand] = newRes;
        trackContext.setIsLoading(false);
        trackContext.setShowLoaderMagic(false);
        trackContext.setTrackData(magicWand);
        trackContext.setTotaltracks(res.total.value);

      } else {
        Helper.handleError(res);
      }
    }).finally(() => {
      trackContext.setShowLoaderMagic(false);
    });

    let filter = trackContext.trackFilter
    filter.selectedChildTags = []
    filter.selectedTags = []
    filter.url = ""
    filter.searchId = "";
    filter.fileName = "";
    filter.searchText = "";
    filter.searchTitle = props.title;
    filter.trackId = props.trackId;
    trackContext.setTrackFilter(filter);
    if (trackContext.path === "/" ||
      trackContext.path.startsWith("/search/track/") ||
      trackContext.path.startsWith("/artist/") ||
      trackContext.path.startsWith("/playlists/") ||
      trackContext.path.startsWith("/album/")
    ) {
      localStorage.setItem("filter_music", JSON.stringify(filter));
    }
    if (trackContext.path === "/sound-design" || trackContext.path.startsWith("/sound-design/search/track/")
    ) {
      localStorage.setItem("filter_soundfx", JSON.stringify(filter));

    }

    if (trackContext.path.startsWith("/playlists/")
    ) {
      localStorage.setItem("filter_playlist", JSON.stringify(filter));
    }

    if (trackContext.path.startsWith("/album/")
    ) {
      localStorage.setItem("filter_album", JSON.stringify(filter));
    }

  };

  const handleAddTrackToFavorites = async(trackData) => {
    if (!trackContext.validateUser(Constants.ACTION.FAVOURITE)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.FAVOURITE);
      return;
    }
    props.setFavingTracks([...props.favingTracks, trackData.trackId]);
    const dataObj = {
      actionType : Constants.ACTION.FAVOURITE,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addTrackToFavorites(dataObj).then((res) => {
      if (res.success) {
        // const favs = JSON.parse(localStorage.getItem("favs") || "[]");
        // if(favs.length === 0 || favs?.indexOf(trackData.trackId) < 0){
        //   favs.push(trackData.trackId)
        // }else{
        //   favs.length > 0 && favs.splice(favs.indexOf(trackData.trackId), 1);
        // }

        localStorage.setItem("favs", JSON.stringify(res.favorites));
        setFavs(Object.keys(res.favorites));
        //changing filterTrackIds if its on favorites page 
        (props.pageId === "favourites" && props.commandOnChange) && props.commandOnChange(Object.keys(res.favorites));
        toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
        
        const tempData = props.favingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(trackData.trackId), 1);
        props.setFavingTracks(tempData);
          
      } else {
        console.log("Adding in favorite list failed.", res);
        toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
      }
    }).catch(err => {
      console.log("Adding in favorite list failed.", err);
      toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
    });

  };

  const handleClose = () => {
    setShowDownloadModal(false);
  };

  const handleDownloadTrack = async (event, trackId) => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
    let currentTarget = event.currentTarget;

    let userData = { id: cachedUserData._id };
    if (cachedUserData?.userType === "ADMIN" || cachedUserData?.userType === "SUPER_ADMIN")
      userData = { id: cachedUserData.email, userType: "ADMIN" };
    await API.validateSubscription(userData.id, userData.userType).then(async (resp) => {
      if (resp?.success) {
        if (resp.data?.userType === "FREE" || !resp.data?.subscribed) {
          trackContext.setShowSubscribePopup(true);
          trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
        } else {
          CookieManager.setCookie("user-data", JSON.stringify(resp.data));
          await API.getDownloadTracks(trackId).then((res) => {
            if (res?.audiofile !== undefined && res.audiofile !== null) {
              setHdmp3File(res.audiofile?.hd_mp3?.url);
              setOriginalFile(res.audiofile?.original.url);
              setDownloadModalPosition(currentTarget);
              setChilddownloadModalPosition(currentTarget);
              setShowDownloadModal(true);
            } else {
              Helper.handleError(res);
            }
          });
        }
      } else {
        toast(({ closeToast }) => <ErrorToast message={resp.mssg} />);
      }
    });

  };

  const handleDownloadArchive = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => {
      if (res?.length > 0) {
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files" />
        ));
      } else {
        toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }
    })
      .catch((err) => {
        Helper.handleError(err);

      });
  };

  const handleArchiveDownload = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => {
      //success : response  = ["taskId"]
      //fail : response : { "status": 400, "message": "\"documentIds\" is required. \"docId\" is not allowed.", "key": "validation_error", "stack": {}, "reqId": "9022499d-9b2b-4edc-9397-c8f8372a83ea" }
      if (Array.isArray(res) && res.length) {
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files." />
        ));
      } else {
        toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }

    });
  };

  const setDownloadHistory = (trackId) => {
    API.setDownloads(trackId).then((res) => {
      const downloadlist = JSON.parse(localStorage.getItem("download")) || [];
      downloadlist.push(trackId);
      setDownload(downloadlist);
      localStorage.setItem("download", JSON.stringify(downloadlist));
    });
  };


  const addSearchTag = (tagId, tagName) => {
    let newTrackFilter = { ...trackContext.trackFilter };
    let newTags = { ...newTrackFilter.searchTags };
    let tags_not = newTags.tags_not || [];
    let Contexttags = newTags.tags || [];
    Contexttags.push(tagId);
    tags_not = tags_not.filter((itemnot) => itemnot !== tagId);
    newTags.tags = Contexttags;
    newTags.tags_not = tags_not;
    newTrackFilter.searchTags = newTags;
    newTrackFilter.fetchList = true;
    newTrackFilter.url = "";
    trackContext.setTrackFilter(newTrackFilter);
  };
  const removeSearchTag = (tagId, tagName) => {
    let newTrackFilter = { ...trackContext.trackFilter };
    let newTags = { ...newTrackFilter.searchTags };
    let tags_or = newTags.tags_or || [];
    let contexttags = newTags.tags || [];
    let tags_not = newTags.tags_not || [];
    if (tags_or.some((item1) => item1.includes(tagId))) {
      tags_not.push(tagId);
      tags_or = tags_or.filter((item) => {
        if (item.every((subItem) => tags_not.includes(subItem))) {
          tags_not = tags_not.filter((itemnot) => !item.includes(itemnot));
          return false;
        }
        return true;
      });
    }
    if (contexttags.includes(tagId)) {
      contexttags = contexttags.filter((item) => item !== tagId);
    }
    newTags.tags_or = tags_or;
    newTags.tags_not = [...tags_not];
    newTags.tags = contexttags;
    newTrackFilter.searchTags = newTags;
    trackContext.setTrackFilter(newTrackFilter);
  };

  const handleMagicWandClick = (trackData) => {
    //TODO : change this as we change musicFilter obj
    const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(CookieManager.getCookie("harmix-music-filter")) : { "searchText": "", "type": Constants.SEARCH_TYPE.text };
    tempFilter.type = Constants.SEARCH_TYPE.track;
    tempFilter.searchText = trackData.title;
    tempFilter.searchRef = trackData.id;
    tempFilter.segment = null;
    CookieManager.setCookie("harmix-music-filter", JSON.stringify(tempFilter));
    history.push(`/library/${trackData.id}`)
  }

  const alternateVersionsProps = {
    albumName : props.album,
    alternateVersions,
    favs,
    setFavs,
    handleAddTrackToFavorites,
    playTrack,
    magicWandSearch,
    handleProjectModal,
    downloadTrack,
    handleClose,
    downloadingTracks : props.downloadingTracks,
    favingTracks : props.favingTracks,
    // setDownloadingTracks : props.setDownloadingTracks
    // setDownloadHistory,
    // handleMagicWandClick
  };

  const handleLoaderWithThumbPrint = () => {
    let newFilter = filterMenu;
    newFilter = newFilter.map((item) => {
      item.count = 0
      return item;
    })
    trackContext.setFilterMenu(newFilter);
    localStorage.setItem("filterMenu", JSON.stringify(newFilter));

    setFilterSubMenu([]);
    setFilterSubMenuchild([]);
    //trackContext.setClearData(true)
    // setShowMayaLoader(true)
    handleThumbPrintSearch(props)

    let searchTitle = ""
    if (props) {

      searchTitle = props.title
    } else {

      searchTitle = trackContext.trackFilter.searchTitle
    }

    if (trackContext.path.startsWith("/search")
      || trackContext.path === "/"
      || trackContext.path.startsWith("/album")
      || trackContext.path.startsWith("/artist")
      || trackContext.path.startsWith("/playlists")
    ) {
      //setting filter data
      if (searchTitle) {
        let tempData = JSON.parse(localStorage.getItem("filterMenu") || {}); tempData.searchTitle = searchTitle;
        localStorage.setItem("filterMenu", JSON.stringify(tempData));
      }
      history.push(`/search/track/`);

    }
    else {
      (
        trackContext.path.startsWith("/playlists/") ? history.push(`/playlists/${playlistId}`)
          :
          trackContext.path.startsWith("/album/") ? history.push(`/album/${albumId}`) :
            history.push(`/sound-design/search/track/`))
    }


  }

  const loadAlbumData = (albumId) => {
    if (!albumId?.length) {
      toast(({ closeToast }) => <ErrorToast message={"Album Id not specified."} />);
      return;
    } else {
      history.push(`/album/${albumId}`);
    }
  }

  const loadArtistData = (artistId) => {
    if (!artistId?.length) {
      toast(({ closeToast }) => <ErrorToast message={"Artist Id not specified."} />);
      return;
    } else {
      history.push(`/artist/${artistId}`);
    }
  }
  return (
    <div
      id={props.trackId}
      className="track-item md:w-1/2  z-[-10] lg:w-full flex flex-wrap bg-white cursor-mouse hover:bg-gray-200 text-red-500 border-b border-symStrokeGrey transition ease-in-out p-2 sm:p-0 w-full border-2 my-0.5"
    >

      <div className="flex  w-full z-[-100] flex-col lg:flex-row lg:justify-between">
        <div className="w-full z-[-50] lg:w-2/5 py-0.5    flex justify-around lg:justify-start "
        // style={{width:"45%"}}
        >
          <div className="flex items-center  gap-4 lg:gap-2">
            {/* Album Image Section */}
            <div className="w-2/3 z-[-10] lg:w-3/4  flex justify-center   sm:justify-start">
              {props.albumId ? (
                <Link className="self-center" to={`/album/${props?.albumId}`}>
                  <img
                    src={Helper.getArtworkURL(props?.albumId) || defaultImage}
                    alt=""
                    onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                    className="w-full border"
                    loading="lazy"
                    style={{width:"95px"}}
                  />
                </Link>
              ) : (
                <img
                  src={defaultImage}
                  alt="Default album cover"
                  style={{width:"95px"}}
                  className="  shadow-md"
                />
              )}
            </div>

            {/* Play/Pause Button */}
            <div className="w-1/3 flex lg:w-1/4   justify-center">
              <button
                aria-label="Play or Pause"
                className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors border border-gray-400 shadow-sm flex items-center justify-center"
                onClick={() => playTrack(props)}
              >
                {trackContext.playPause &&
                  props.trackId === trackContext.currentTrackDetail.id &&
                  trackContext.playingFrom === props.pageId ? (
                  <Pause className="w-8 h-8 text-gray-700" />
                ) : (
                  <Play className="w-8 h-8 text-gray-700" />
                )}
              </button>
            </div>
          </div>

          <div
            className="w-full sm:w-7/12 lg:w-3/4 p-2    cursor-pointer"
            onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
            style={{ overflow: "hidden" }}
          >
            <div className="track-title font-semibold text-sm sm:text-base">
              {props?.title?.toLowerCase()}
            </div>
            <div className="track-artist text-xs sm:text-sm">
              {props.artistName}
            </div>
            <div className={`text-description text-xs sm:text-sm ${expand ? "text-all" : "desc-style"}`}>
              {props?.description !== undefined && props?.description?.length > 0 ? props.description : ""}
            </div>
          </div>
        </div>
       <div className="w-full lg:w-3/5 flex flex-col lg:flex-row justify-start lg:justify-between   px-0    self-center">
     
       <div className="w-full lg:w-6/12     flex justify-start self-center">
          {props.waveform?.length > 0 && 
          <img
            src={props.waveform}
            alt=""
            className="w-full"
            loading="lazy"
          />}
        </div>

        <div className="flex  w-full  lg:w-3/12 text-gray-500 self-center  flex-row  justify-end    px-2 lg:px-0 lg:text-right text-center">
            {props.versions !== undefined && props.versions > 0 &&
              <div className="w-6 h-6 ml-4 md:ml-0 text-white bg-black text-xs flex items-center justify-center rounded-full">
                <>
                  <span className="mb-1">+</span>
                  <span>{props.versions}</span>
                </>
              </div>
            }
            <div className="flex w-11/12 justify-end lg:justify-center lg:w-3/4 lg:mb-1    lg:self-center">
            <div className=" text-center  ml-2 lg:ml-0 w-2/12 text-xs self-center  block text-black font-medium">
              {props.bpm !== undefined ? Math.round(props.bpm) + "BPM" : null}
            </div>
            <div className=" text-center ml-5 lg:ml-12   w-2/12 text-xs self-center block text-black font-medium">
              {props.duration &&
                new Date(props.duration * 1000).toISOString().substr(14, 5)}
            </div>
          </div>
        </div>

         
        <div className="w-full flex gap-x-6  lg:w-3/12  px-4 lg:px-0 lg:gap-x-0  justify-evenly lg:justify-end  self-center">
         
          <ThumbPrint
            className="trackicon thumbprint-icon w-8  sm:w-6 sm:mb-4 sm:mt-5 md:ml-2 sm:right-0 self-center cursor-pointer thumb-print"
            onClick={() => magicWandSearch({ id: props.trackId, title: props.title, albumId : props.albumId, artist : props.artistName, duration : props.duration })}
          />

          {favs?.indexOf(props.trackId) !== -1 ? (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
            <FavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "20px" }}
              className="fav-icon  sm:m-1 sm:mr-2 self-center sm:right-0 cursor-pointer text-ctaRed"
            />

          ) : (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
            <UnFavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "20px" }}
              className="trackicon unfav-icon  sm:m-1 sm:mr-2 self-center sm:right-0 cursor-pointer text-gray-600 hover:text-ctaRed"
            />
          )}
          <CreateNewFolderIcon
            style={{ marginTop: "12px" }}
            onClick={() => handleProjectModal({trackId : props.trackId, albumId : props.albumId, artworkRef : Helper.getArtworkURL(props.albumId), audioRef : Helper.playTrackURL(props.trackId)})}
            className="trackicon folder-icon  mt-2 sm:m-1 sm:mt-2 self-center sm:right-0 cursor-pointer text-gray-700 hover:text-blue-600"
          />
          {download?.indexOf(props.trackId) !== -1 ? (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
            <Activedownload
              onClick={(event) => downloadTrack(props.trackId)}
              style={{ fontSize: "24px" }}
                className="trackicon  mt-5  self-center right-0 cursor-pointer text-gray-700   block"
            />
          ) : (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="pt-3 pr-1" ><CircularProgress size='18px'/></div> : 
            <GetAppIcon
              onClick={(event) => downloadTrack(props.trackId)}
              style={{ fontSize: "22px" }}
              className="trackicon  mt-5  self-center right-0 cursor-pointer text-gray-700   block"
            />
          )}
          {expand && props.expandedTrackId === props.trackId ? (
            <ExpandLessIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "33px" }}
              className="trackicon self-center  cursor-pointer text-gray-700"
            />
          ) : (
            <ExpandMoreIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "33px" }}
              className="trackicon self-center  cursor-pointer text-gray-700"
            />
          )}
        </div>
       
        {/* <Menu
          id="customized-menu"
          anchorEl={downloadModalPosition}
          open={Boolean(showDownloadModal)}
          onClose={handleClose}
          style={{ width: "320px" }}
        >
          <MenuItem className="card-action">
            <a
              href={originalFile}
              target="_blank"
              rel="noopener noreferrer"
              download=""
            >
              Original HD - Single track
            </a>
          </MenuItem>
          <MenuItem
            onClick={() => { handleArchiveDownload(props.trackId, "original"); setShowDownloadModal(false) }}
            className="card-action"
          >
            <span className="card-action-text">
              Original HD - All versions
            </span>
          </MenuItem>
          <MenuItem
            onClick={() => { setDownloadHistory(props.trackId); setShowDownloadModal(false) }}
            className="card-action"
          >
            <a
              href={hdmp3File}
              target="_blank"
              rel="noopener noreferrer"
              download=""
            >
              MP3 - Single track
            </a>
          </MenuItem>
          <MenuItem
            onClick={() => { handleArchiveDownload(props.trackId, "hd_mp3"); setShowDownloadModal(false) }}
            className="card-action"
          >
            <span className="card-action-text">
              MP3 - All versions
            </span>
          </MenuItem>
        </Menu> */}
       </div>
      </div>

      {expand && props.expandedTrackId === props.trackId && (
        <div className="alternative-versions-wrapper w-full">
          <div className="hidden lg:w-12/12 lg:flex lg:flex-wrap lg:text-gray-600 lg:my-4 lg:self-center">
            <Tabs
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              className="p-3 w-full"
              value={0}
            >
              {props.tags?.sort((a, b) => (a.names[0].value < b.names[0].value ? -1 : 1))
                ?.map((tag, index) => (
                  <div
                    key={tag.id}
                    value={index}
                    onClick={() => {
                      if (
                        !(
                          (searchTags.tags_or?.some((item1) =>
                            item1.includes(tag.id)
                          ) &&
                            !searchTags.tags_not?.includes(tag.id)) ||
                          searchTags.tags?.includes(tag.id)
                        )
                      )
                        addSearchTag(
                          tag.id,
                          [...tag.names]?.map((eachTagName) =>
                            eachTagName.locale === "en"
                              ? eachTagName.value
                              : null
                          )
                        );
                    }}
                    className={
                      (searchTags.tags_or?.some((item1) =>
                        item1.includes(tag.id)
                      ) &&
                        !searchTags.tags_not?.includes(tag.id)) ||
                        searchTags.tags?.includes(tag.id)
                        ? `flex pt-1 pb-1 pl-2 pr-2 mr-1 mb-1 text-xs border text-symTextGrey border-symStrokeGrey bg-symbgGray rounded-full cursor-pointer`
                        : `flex pt-1 pb-1 pl-2 pr-2 mr-1 mb-1 text-xs border text-symTextGrey border-symStrokeGrey rounded-full cursor-pointer hover:bg-symbgGray hover:scale-75`
                    }
                  >
                    {[...tag.names]?.map((eachTagName) =>
                      eachTagName.locale === "en" ? eachTagName.value : null
                    )}
                    {((searchTags.tags_or?.some((item1) =>
                      item1.includes(tag.id)
                    ) &&
                      !searchTags.tags_not?.includes(tag.id)) ||
                      searchTags.tags?.includes(tag.id)) && (
                        <Close
                          onClick={(e) => {
                            e.stopPropagation();
                            removeSearchTag(
                              tag.id,
                              [...tag.names]?.map((eachTagName) =>
                                eachTagName.locale === "en"
                                  ? eachTagName.value
                                  : null
                              )
                            );
                          }}
                          className="mt-1 ml-1"
                        />
                      )}
                  </div>
                ))}
            </Tabs>
          </div>
          <div className="lg:hidden w-full mr-2 flex flex-wrap text-gray-600 self-center">
            {props.tags?.sort((a, b) => (a.names[0].value < b.names[0].value ? -1 : 1))
              ?.map((tag, index) => (
                <div
                  key={tag.id}
                  value={index}
                  onClick={() => {
                    if (
                      !(
                        (searchTags.tags_or?.some((item1) =>
                          item1.includes(tag.id)
                        ) &&
                          !searchTags.tags_not?.includes(tag.id)) ||
                        searchTags.tags?.includes(tag.id)
                      )
                    )
                      addSearchTag(
                        tag.id,
                        [...tag.names]?.map((eachTagName) =>
                          eachTagName.locale === "en" ? eachTagName.value : null
                        )
                      );
                  }}
                  className={
                    (searchTags.tags_or?.some((item1) =>
                      item1.includes(tag.id)
                    ) &&
                      !searchTags.tags_not?.includes(tag.id)) ||
                      searchTags.tags?.includes(tag.id)
                      ? `flex pt-1 pb-1 pl-2 pr-2 mr-2 mb-2 text-xs border text-symTextGrey border-symStrokeGrey bg-symbgGray rounded-full cursor-pointer`
                      : `flex pt-1 pb-1 pl-2 pr-2 mr-2 mb-2 text-xs border text-symTextGrey border-symStrokeGrey rounded-full cursor-pointer hover:bg-symbgGray hover:scale-75`
                  }
                >
                  {[...tag.names]?.map((eachTagName) =>
                    eachTagName.locale === "en" ? eachTagName.value : null
                  )}
                  {((searchTags.tags_or?.some((item1) =>
                    item1.includes(tag.id)
                  ) &&
                    !searchTags.tags_not?.includes(tag.id)) ||
                    searchTags.tags?.includes(tag.id)) && (
                      <Close
                        onClick={(e) => {
                          e.stopPropagation();
                          removeSearchTag(
                            tag.id,
                            [...tag.names]?.map((eachTagName) =>
                              eachTagName.locale === "en"
                                ? eachTagName.value
                                : null
                            )
                          );
                        }}
                        className="mt-1 ml-1"
                      />
                    )}
                </div>
              ))}
          </div>
          {/* <div className="flex flex-wrap w-1/2 mt-4">
        <div className="sm:hidden text-center ml-2 w-2/12 text-sm self-center block text-black font-medium">
          {props.bpm !== undefined ? Math.round(props.bpm) + "BPM" : null}
        </div>
        <div className="sm:hidden text-center ml-12 w-2/12 text-sm self-center block text-black font-medium">
          {props.duration &&
            new Date(props.duration * 1000).toISOString().substr(14, 5)}
        </div>
      </div> */}
          <div className="ml-1 album-info w-full lg:ml-16 lg:w-5/6">
            <div className="flex flex-wrap mt-2 md:w-4/6 sm:mt-2 md:flex md:mb-4">
              <div className="pr-8 pb-2">
                <p className="text-title text-gray-600">Album</p>
                <h3 className="track-artist hover:underline font-bold">
                  <div className="cursor-pointer" onClick={() => loadAlbumData(props.albumId)}>{props.album}</div>
                </h3>
              </div>
              <div className="pr-8 pb-2">
                <p className="text-title text-gray-600">Artists</p>
                {props.artists?.map((elem) => {
                  return (
                    <div className="track-artist font-bold hover:underline"> 
                    {/* onClick={() => elem.artist.id && loadArtistData(elem.artist.id)}> */}
                      {elem.artist.full_name}
                    </div>
                  );
                })}
              </div>
              <div className="pr-8 pb-2">
                <p className="text-title text-gray-600">Producer</p>
                <h3 className="track-artist font-bold">{props.producer}</h3>
              </div>
            </div>
          </div>
          {(props.versions > 0 && alternateVersions?.length > 0) && (
            <div className="lg:ml-10 lg:w-full lg:pr-16 lg:pl-8">
              <p className="text-title text-gray-600">
                Alternative versions
              </p>
              <div className="lg:px-8 py-2" style={{ backgroundColor: "#F5F5F5" }}>
                <AlternateTracks {...alternateVersionsProps} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}